export {browserSession} from "../shared/session/browser-session";
import {sessionStore} from "../shared/session/session-store";

const trigger = document.querySelector<HTMLAnchorElement>("[data-auth-trigger]");

if (trigger) {
  trigger.addEventListener("click", async (event) => {
    if (sessionStore.snapshot().status === "authenticated") return;
    event.preventDefault();
    try {
      const {mountAuthDialog} = await import("../features/auth/ui/mount-dialog");
      mountAuthDialog(trigger, "signup");
    } catch {
      window.location.assign(trigger.href);
    }
  });

  void sessionStore.bootstrap().then(async () => {
    const state = sessionStore.snapshot();
    if (state.status === "authenticated") {
      const {default: i18n} = await import("../shared/i18n");
      trigger.textContent = i18n.t("session.accountLink", {name: state.me.first_name});
      trigger.href = "/app/";
      trigger.dataset.authenticated = "true";
    }
  });
}
